export const ANALYSIS_VERSIONS = {
    V2: 'V2',
    V3: 'V3'
}

export const ANALYSIS_VERSION_TABS = [
    {
        version: ANALYSIS_VERSIONS.V2,
        name: '기존 IQR',
        description: '일자별 출고합계 분포에 IQR / winsorize 를 적용합니다.'
    },
    {
        version: ANALYSIS_VERSIONS.V3,
        name: 'IQR V3',
        description: '개별 주문건을 판정 대상으로 삼아 일회성 대량 주문건을 총량에서 제외합니다.'
    }
]

export const DEFAULT_ANALYSIS_VERSION = ANALYSIS_VERSIONS.V2;
